import React, { useEffect, useState } from "react";
import { getCartItemCount } from "../../helpers/getWooCommerceCartItems";

const WP_URL = process.env.REACT_APP_WP_URL || "https://mycover-up.fr";
const LOGO_URL = `${WP_URL}/react-app/logo-horizontal-couleur.webp`;

function McuHeader() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    setCartCount(getCartItemCount());
  }, []);

  return (
    <header className="mcu-header" id="mcu-header">
      <div className="mcu-topbar">
        <div className="mcu-topbar__inner">
          <span className="mcu-topbar__promo">
            🚛 Livraison offerte en France métropolitaine&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;🎁 24€ de remise dès le 2ème cache
          </span>
          <a href={`${WP_URL}/contact`} className="mcu-topbar__link">
            Contact
          </a>
          <span className="mcu-topbar__sep" aria-hidden="true">
            |
          </span>
          <a href="tel:0582950583" className="mcu-topbar__phone">
            05 82 95 05 83
          </a>
        </div>
      </div>

      <nav className="mcu-navbar" aria-label="Navigation principale">
        <div className="mcu-navbar__inner">
          <div className="mcu-navbar__nav">
            <a href={`${WP_URL}/decouvrir-mycoverup`} className="mcu-navbar__link">
              À propos
            </a>
            <a href={`${WP_URL}/boutique`} className="mcu-navbar__link">
              Catalogue
            </a>
            <a href={`${WP_URL}/nos-realisations`} className="mcu-navbar__link">
              Réalisations
            </a>
            <a href={`${WP_URL}/espace-pro`} className="mcu-navbar__link">
              Espace Pros
            </a>
          </div>

          <a href={`${WP_URL}/`} className="mcu-navbar__logo-link">
            <img
              src={LOGO_URL}
              alt="myCover'Up"
              className="mcu-navbar__logo"
              width="538"
              height="112"
            />
          </a>

          <div className="mcu-navbar__actions">
            <a
              href={`${WP_URL}/support-mycover-up`}
              className="mcu-cta mcu-cta--primary mcu-cta--sm"
            >
              Support
            </a>
            <a
              href={`${WP_URL}/configurateur/`}
              className="mcu-cta mcu-cta--accent mcu-cta--sm"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="2.5" fill="currentColor" />
              </svg>
              Créer mon cache
            </a>

            <a
              href={`${WP_URL}/espace-client/`}
              className="mcu-navbar__icon"
              aria-label="Mon compte"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </a>

            <a
              href={`${WP_URL}/panier/`}
              className="mcu-navbar__icon mcu-navbar__icon--cart"
              aria-label="Panier"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              {cartCount > 0 && (
                <span className="mcu-cart-badge">{cartCount}</span>
              )}
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default McuHeader;
